import installIcon from "@/assets/app-install-icon.svg";
import { useTranslation } from "@/hooks/useTranslation";
import { Button } from "../ui/button";
import { useState } from "react";
import { Dialog } from "../ui/dialog";
import AppInstallDialogContent from "../AppIntallDialogContent";

export default function AppInstallCard() {
  const [installAppOpen, setInstallAppOpen] = useState(false);
  const t = useTranslation();

  return (
    <>
      <div className="dark bg-zinc-950 w-full max-w-lg border rounded-lg p-6">
        <div className="flex flex-row items-center gap-6">
          <img src={installIcon} alt="Pulse Logo" className="w-16" />
          <Button
            variant="default"
            className="items-center rounded-lg mb-4"
            onClick={() => setInstallAppOpen(true)}
          >
            {t.APP_INSTALL_DIALOG.LABELS.DIALOG_TITLE}
          </Button>
        </div>
      </div>

      <Dialog
        open={installAppOpen}
        onOpenChange={() => setInstallAppOpen(false)}
      >
        <AppInstallDialogContent t={t} />
      </Dialog>
    </>
  );
}
